import axiosInstance from '../../../config/axiosConfig';
import { urlTiposActivos } from '../../../config/apiURL';
import { extractArray, extractDataObject } from '../../utils/responseHelpers';

// Obtener todos los tipos de activos
export async function getTiposActivos() {
  try {
    const response = await axiosInstance.get(urlTiposActivos);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching tipos activos:', error);
    throw error;
  }
}

// Obtener un tipo de activo por ID
export async function getTipoActivoById(id) {
  try {
    const response = await axiosInstance.get(`${urlTiposActivos}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error fetching tipo activo ${id}:`, error);
    throw error;
  }
}

export async function createTiposActivos(formulario) {
  try {
    const response = await axiosInstance.post(urlTiposActivos, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error creating tipo activo:', error);
    throw error;
  }
}

export async function updateTiposActivo(id, formulario) {
  try {
    const response = await axiosInstance.put(`${urlTiposActivos}/${id}`, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error updating tipo activo ${id}:`, error);
    throw error;
  }
}

export async function deleteTiposActivos(id) {
  try {
    const response = await axiosInstance.delete(`${urlTiposActivos}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deleting tipo activo ${id}:`, error);
    throw error;
  }
}